import { render, staticRenderFns } from "./SponsorsByAirTime.vue?vue&type=template&id=9612cf12&"
import script from "./SponsorsByAirTime.vue?vue&type=script&lang=js&"
export * from "./SponsorsByAirTime.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsByAirTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports